export default "__VITE_ASSET__CTuVsEOu__"